import { render, staticRenderFns } from "./IndexArticle.vue?vue&type=template&id=2e653e47&scoped=true"
import script from "./IndexArticle.vue?vue&type=script&lang=js"
export * from "./IndexArticle.vue?vue&type=script&lang=js"
import style0 from "./IndexArticle.vue?vue&type=style&index=0&id=2e653e47&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e653e47",
  null
  
)

export default component.exports